import "../ClaimDetails.scss";
import { Modal, Select } from "antd";
import CustomLine from "../../../Components/Line/line";
import { LuClipboardList } from "react-icons/lu";
import { useMemo, useState } from "react";
import { BsInputCursorText } from "react-icons/bs";
const { Option } = Select;
const ReturnClaimReasonDialog = ({
  itemName,
  close,
  open,
  rejectAndReturnClaim,
  itemType,
  arabicType,
  itemInsuranceShare,
  itemPatientShare,
  totalPrice,
}) => {
  const [reason, setReason] = useState();
  const [comment, setComment] = useState("");
  const [missingFieldError, setMissingFieldError] = useState(false);
  const reasonsListForClaim = useMemo(() => {
    return [
      "تم الالغاء حيث أنه لم يتم الصرف",
      "تم الالغاء بناءً علي طلب العميل",
      "تم الالغاء حيث أنه قد تم صرفها بالخطأ",
      "تم صرف العلاج ماعدا هذا الصنف (لعدم توافره بناءً علي طلب العميل)",
    ];
  }, []);
  return (
    <Modal
      open={open}
      title={false}
      footer={false}
      direction="rtl"
      closeIcon={true}
      style={{
        maxHeight: "90vh",
        overflowY: "auto",
        fontSize: "1vw",
        padding: "0",
        borderRadius: "20px",
        overlay: { backgroundColor: "rgba(167, 167, 167, 0.4)" },
        textAlign: "right",
      }}
      centered
      onCancel={() => {
        close();
      }}
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        <LuClipboardList style={{ fontSize: "1vw", margin: "0 7px" }} />
        <div>
          <p
            style={{ textAlign: "right", fontSize: "1vw", fontWeight: "bold" }}
          >
            استرجاع خدمة/دواء
          </p>
          <CustomLine width={"110px"} />
        </div>
      </div>
      <div className={"Card"} style={{margin:"10px 0",padding:"5px 10px"}}>
        <ul className="ulNormal">
          <li>
            <span>اسم الخدمة/الدواء: </span>
            <span>{itemName}</span>
          </li>
          {arabicType && (
            <li>
              <span>نوع الخدمة: </span>
              <span>{arabicType}</span>
            </li>
          )}
          {totalPrice && (
            <li>
              <span>السعر الاجمالى للخدمة: </span>
              <span>{totalPrice}</span>
            </li>
          )}
          {itemInsuranceShare === undefined ?<></> :(
            <li>
              <span>قيمة تحمل التأمين: </span>
              <span>{itemInsuranceShare}</span>
            </li>
          )}
          {itemPatientShare === undefined ?<></> :(
            <li>
              <span>قيمة تحمل المريض: </span>
              <span>{itemPatientShare}</span>
            </li>
          )}
        </ul>
      </div>
      <div>
        <span>
          <p>سبب الاسترجاع</p>
          {missingFieldError && !reason && (
            <p style={{ color: "red", fontSize: "0.8vw" }}>
              ( يجب اختيار سبب الاسترجاع )
            </p>
          )}
          <Select
            style={{
              width: "100%",
              borderRadius: "8px",
              border: missingFieldError && !reason ? "1px solid red" : "",
            }}
            dropdownStyle={{ direction: "rtl" }}
            placeholder="اختر سبب الاسترجاع"
            onChange={(e) => {
              setReason(e);
            }}
          >
            {reasonsListForClaim.map((reason) => (
              <Option key={reason} value={reason}>
                {reason}
              </Option>
            ))}
          </Select>
        </span>
        <span>
          <p>ملحوظة</p>
          <div>
            <textarea
              style={{
                height: "4em",
                border: "1px solid #d9d9d9",
                width: "100%",
                borderRadius: "8px",
              }}
              type="text"
              placeholder="ملحوظة"
              value={comment}
              onChange={(e) => {
                setComment(e.target.value);
              }}
            />
          </div>
        </span>
      </div>
      <div
        style={{
          margin: "10px 0",
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <button
          className="button"
          style={{
            fontSize: "1vw",
            backgroundColor: "#1cc9bc",
            width: "45%",
          }}
          onClick={() => {
            if (!reason) {
              setMissingFieldError(true);
              return;
            }
            rejectAndReturnClaim({
              reason,
              comment,
            });
          }}
        >
          تأكيد
        </button>

        <button
          className="button"
          style={{ fontSize: "1vw", width: "45%" }}
          onClick={() => {
            close();
          }}
        >
          إغلاق
        </button>
      </div>
    </Modal>
  );
};
export default ReturnClaimReasonDialog;
